export { default as deDEMessages } from "../locales/de-DE/messages.json" with {
  type: "json",
}
// Export locale messages
export { default as enUSMessages } from "../locales/en-US/messages.json" with {
  type: "json",
}
export { default as esMessages } from "../locales/es/messages.json" with {
  type: "json",
}
export { default as frMessages } from "../locales/fr/messages.json" with {
  type: "json",
}
export { default as jaMessages } from "../locales/ja/messages.json" with {
  type: "json",
}
export { default as krMessages } from "../locales/kr/messages.json" with {
  type: "json",
}
export { default as zhCNMessages } from "../locales/zh-CN/messages.json" with {
  type: "json",
}
export { default as zhTWMessages } from "../locales/zh-TW/messages.json" with {
  type: "json",
}
export { DEFAULT_TIMEZONE } from "./constants"
export { EM_DASH } from "./formatters/constants"
export { dateTimeFormatter } from "./formatters/dateTime"
export type { NumberFormatOptions } from "./formatters/number"
export {
  getBoundedNumber,
  getNumberFormatOptions,
  getNumberFormatOptionsByDisplay,
  getNumberPrefix,
  isValidNumber,
  numberFormatter,
  ONE_BIL,
} from "./formatters/number"
export {
  type RelativeTimeOptions,
  relativeTimeFormatter,
} from "./formatters/relativeTime"
export type {
  DateTimeDisplay,
  NumberFormatDisplay,
  RelativeTimeDisplay,
} from "./formatters/types"
export { useDateTimeFormatter } from "./hooks/useDateTimeFormatter"
export { useLocale } from "./hooks/useLocale"
export { useNumberFormatter } from "./hooks/useNumberFormatter"
export { useRelativeTimeFormatter } from "./hooks/useRelativeTimeFormatter"
export { LocaleContext, LocaleProvider } from "./providers/LocaleProvider"
export type { Locale } from "./types"

import deDE from "../locales/de-DE/messages.json" with { type: "json" }
// Helper to get messages by locale
import enUS from "../locales/en-US/messages.json" with { type: "json" }
import es from "../locales/es/messages.json" with { type: "json" }
import fr from "../locales/fr/messages.json" with { type: "json" }
import ja from "../locales/ja/messages.json" with { type: "json" }
import kr from "../locales/kr/messages.json" with { type: "json" }
import zhCN from "../locales/zh-CN/messages.json" with { type: "json" }
import zhTW from "../locales/zh-TW/messages.json" with { type: "json" }

const messagesMap = {
  "en-US": enUS,
  "de-DE": deDE,
  es,
  fr,
  ja,
  kr,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
}

export function getMessages(locale: string) {
  return messagesMap[locale as keyof typeof messagesMap] ?? enUS
}

export { messagesMap }
